import axios from "../../utils/axios";

export const fetchSupplierDetails = async (supplierId) => {
  return await axios.get(`/suppliers/${supplierId}/`);
};

export const fetchSupplierProducts = async (requestParams) => {
  return await axios.get("/products-search/", null, { ...requestParams });
};

export const getProduct = async (productId) => {
  return await axios.get(`/products/${productId}/`);
};

export const fetchSupplierReviews = (requestParams) => {
  return axios.get(`/consumer-ratings/listing/supplier`, null, { ...requestParams });
};
